import { chatbotApi } from "..";

interface MessageRequest {
  id: string;
  message: string;
  type: string;
}

export const createMessage = async (
  data: MessageRequest,
  onMessage: (text: string, isError?: boolean) => void,
  onError?: (error: any) => void
): Promise<void> => {
  try {
    const response = await fetch(
      `${chatbotApi.defaults.baseURL}/conversations/message`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }
    );

    if (!response.ok || !response.body) {
      throw new Error("Failed to connect to the event stream.");
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = "";

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      buffer += decoder.decode(value, { stream: true });

      const messages = buffer.split("\n\n");
      buffer = messages.pop() || "";

      for (const message of messages) {
        if (message.startsWith("data: ")) {
          try {
            const parsed = JSON.parse(message.replace("data: ", ""));
            const isError = Boolean(parsed?.error);
            const content = isError ? parsed.error : parsed.text ?? "";

            onMessage(content, isError);
          } catch (err) {
            console.error("Failed to parse SSE message:", err);
          }
        }
      }
    }
  } catch (error) {
    console.error("SSE error:", error);
    if (onError) onError(error);
  }
};
